import { format } from 'd3-format'
import { useDimensionsContext } from '../Chart'

export const XAxis = ({ x }) => {
  const xTicks = x.ticks(5)
  const dimensions = useDimensionsContext()
  return (
    <g className="axis" transform={`translate(0, ${dimensions.boundedHeight})`}>
      {xTicks.map((tick, i) => {
        return (
          <g
            key={tick}
            style={{
              transform: `translate(${x(tick)}px, 0)`
            }}
          >
            <line className="dashed-line" y2={-dimensions.boundedHeight}></line>
            <text y={25} dy="0.71em">
              {tick}
            </text>
          </g>
        )
      })}
    </g>
  )
}

export const YAxis = ({ y }) => {
  const formatMill = format('.0s')

  const yTicks = [-6000000, -3000000, 0, 3000000]

  return (
    <g className="axis vertical">
      {/* <line className="xAxis line" x2={dimensions.boundedWidth} /> */}
      {yTicks.map((tick, i) => {
        return (
          <g
            key={tick}
            style={{
              transform: `translate(0, ${y(tick)}px)`
            }}
          >
            <text x={-30}>{tick === 0 ? '0 jobs' : formatMill(tick)}</text>
          </g>
        )
      })}
    </g>
  )
}
